import $ from "jquery";

// Generated by CoffeeScript 1.12.2
let Tabbed_Sections;

Tabbed_Sections = () => {
  let tabbed_container;
  tabbed_container = $(".tabbed-container");
  return {
    init() {
      let me;
      me = this;
      return $(".tabbed-nav a").on("click", function(e) {
        let new_tab_section;
        let tab;
        e.preventDefault();
        new_tab_section = $(this).attr("href");
        console.log(`Context tab is: ${new_tab_section}`);
        tab = $(this).parents(".tab");
        return me.switch_tab(tab, new_tab_section);
      });
    },
    switch_tab(tab, new_tab) {
      let activateTimeout;
      $(".tabbed-nav .tab").removeClass("active");
      tab.addClass("animating");
      tabbed_container.addClass("animating");
      $(".tabbed-section")
        .removeClass("visible-tab")
        .addClass("hidden-tab");
      clearTimeout(activateTimeout);
      return (activateTimeout = setTimeout(() => {
        tabbed_container.removeClass("animating");
        $(".tabbed-section")
          .removeClass("visible-tab")
          .addClass("hidden-tab");
        $(".tabbed-nav .tab").removeClass("active");
        tab.removeClass("animating").addClass("active");
        $(new_tab)
          .removeClass("hidden-tab")
          .addClass("visible-tab");
        if (new_tab === "#brief") {
          $("#upload-button")
            .addClass("on-brief")
            .removeClass("bottom stuck");
          return $(".key-requirements")
            .addClass("on-brief")
            .removeClass("bottom stuck");
        } else {
          return $("#upload-button").removeClass("on-brief");
        }
      }, 350));
    }
  };
};

export default Tabbed_Sections().init();
